/**
 * Typed `set_field` values for the agency exception detail. Mirrors the ops console's
 * `parseFieldValue` (ops-console/src/components/billing/ruleModel.ts); the two apps share no code.
 */

export type ParsedFieldValue = { ok: true; value: string | number | string[] } | { ok: false; error: string };

function splitList(raw: string): string[] {
  return raw
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
}

/** modifiers → string[] (comma-separated, upper-cased 2-char codes); units → positive integer; others → trimmed string. */
export function parseFieldValue(field: string, raw: string): ParsedFieldValue {
  const v = raw.trim();
  if (field === 'modifiers') {
    const list = splitList(v).map((m) => m.toUpperCase());
    return list.every((m) => /^[A-Z0-9]{2}$/.test(m)) ? { ok: true, value: list } : { ok: false, error: 'Modifiers are 2-character codes, separated by commas.' };
  }
  if (!v) return { ok: false, error: 'Enter a value.' };
  if (field === 'units') {
    const n = Number(v);
    return Number.isInteger(n) && n > 0 ? { ok: true, value: n } : { ok: false, error: 'Units must be a whole number above 0.' };
  }
  return { ok: true, value: v };
}
